import 'jquery';

(function ($) {

  var concat = $('[data-concat-target]'),
    submitted = false,
    inputs = concat.find('input'),
    fill = function () {
      var code = '',
        form = concat.closest('form'),
        value = '',
        target = $(concat.data('concat-target'));

      if (target.length) {
        inputs.each(function () {
          code += $(this).val();
        });
        target.val(code);
      }

      value = code.replace(/[^\d]+/, ''); //   parseInt(code, 10) + '';

      if (value.length === 6 && submitted === false) {
        submitted = true;
        // form.find(':submit').prop('disabled', false);
        form.get(0).submit();
      }
    };

  if (!concat.length) {
    return;
  }

  // window.setInterval(() => { fill(); }, 500);

  concat.on('change', 'input', function () {
    fill();
  });

  concat.on('input', 'input', function () {
    fill();
  });

  concat.on('keyup', 'input', function () {
    fill();
  });

  concat.on('focusout', 'input', function () {
    fill();
  });

  concat.on('blur', 'input', function () {
    fill();
  });

  concat.parents('form').on('submit', function () {
    fill();
  });

  // Detect mobile browsers
  // change input type to number
  // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  //   inputs.attr('type', 'number');
  // }

  concat.find('input:first').get(0).focus();

}(jQuery));
